import React from 'react';
import { colours } from 'utils/theme';
import {
  SpellCheckBox,
  SpellCheckMessage,
  SpellCheckSuggestionButton,
  ErrorIcon,
} from './styled';

const entityTypeLabel = entityType => {
  switch ((entityType || '').toLowerCase()) {
    case 'researchers':
      return 'Contacts';
    case 'organisations':
      return 'Organisations';
    case 'activities':
      return 'Activities';
    default:
      return entityType;
  }
};

/**
 * Shows candidate entity-type pill(s) in the same yellow warning box
 * style as spellcheck. One pill per suggested type; clicking dispatches onChoose(entityType).
 *
 * Props:
 *   suggestedTypes - array of entity-type name strings (e.g. ["organisations", "researchers"])
 *   onChoose       - (entityType) => void
 *   disabled       - bool
 */
export function EntityDisambiguationChooser({
  suggestedTypes,
  onChoose,
  disabled,
}) {
  if (!suggestedTypes || suggestedTypes.length === 0) return null;

  return (
    <SpellCheckBox>
      <ErrorIcon icon='error' size='sm' color={colours.character.warning} />
      <SpellCheckMessage>
        Do you want to change the search context to:
        {suggestedTypes.map(entityType => (
          <SpellCheckSuggestionButton
            key={entityType}
            data-testid={`nlp-disambiguate-${entityType}`}
            onClick={() => onChoose(entityType)}
            disabled={disabled}
          >
            {entityTypeLabel(entityType)}
          </SpellCheckSuggestionButton>
        ))}
      </SpellCheckMessage>
    </SpellCheckBox>
  );
}
